<template>
  <div class="hello">
    <div class="wechat-user-logo">
      <img :src="user.userlogo" />
    </div>
    <div class="title1">

    </div>
    <div class="title2">
      已绑定手机号：{{ user.userphone }}，可接收单位设备的报警信息。
    </div>
    <div class="tip">* 解绑可更换手机号。</div>
    <button class="btn-gray" @click="unbindWeChat">解绑</button>
  </div>
</template>
<script>
import * as dd from "dingtalk-jsapi";
import { MessageBox } from "mint-ui";
import CryptoJS from "crypto-js";
export default {
  name: "ddbindDetail",
  data() {
    return {
      resultlist:"",
      resultuser: "",
      resultdata: "",
      ddAgentId: "",
      codedd: "1d1b1618488e3f5894098c07dc94c3ea",
      access_token: "",
      isShow: false,
      request: {
        phone: "",
        openId: "",
        isPc: "",
        forwardType: "",
      },
      user: {},
      platform: "",
      getAccessTokendata: "",
      ddCodedata: "1",
      userCode: "",
    };
  },
  mounted() {
    this.request.forwardType = this.$route.query.forwardType;
    console.log(this.request.forwardType);
    if (this.request.openId) {
    }
    this.getUserInfo();
  },
  methods: {
    ddcode() {
      if (dd.env.platform !== "notInDingTalk") {
        this.userCode += "开始执行ready ";
        //进行钉钉登录操作
        dd.ready(() => {
          this.userCode = "进入了钉钉 ";
          dd.runtime.permission.requestAuthCode({
            corpId: this.ddCorpId, // 企业id
            onSuccess: (info) => {
              //todo: 测试获取授权码
              this.userCode += " 获取授权码成功 ";
              this.userCode += info.code;
              this.codedd = info.code; // 通过该免登授权码可以获取用户身份
              this.ddIsOkj();
            },
            onFail: (error) => {
              this.userCode += " 获取授权码失败 ";
              console.log("好吧，问题不小");
              this.$Message.error(JSON.stringify(error));
            },
          });
        });
      }
    },

    //调用接口查询要绑定的用户信息
    getUserInfo() {
      // console.log(this.deCodeDES("KHLSxLH9ODo="));
      // console.log(this.encryptByDES(this.deCodeDES("KHLSxLH9ODo=")));

      console.log("zou");

      var yuming = window.location.href.split("/")[2];
      if (
        yuming.indexOf("localhost") >= 0 ||
        yuming.indexOf("192.168.1") >= 0 ||
        yuming.indexOf("192.168.0.109") >= 0
      ) {
        var yuming = "https://www.lny119.com";
      }
      //如果查询到则弹出是否绑定确认框,否则提示无此账号
      var _t = this;
      this.common.doActionGet(
        this.common.getAccessToken,
        { ddIndexUrl: yuming },
        function (res) {
          console.log(res);
          _t.getAccessTokendata = res;
          if (res.code == 200) {
            //绑定成功,跳转到详情页bindDetail,否则提示失败原因
            // _t.user=res.data;
            // _t.request.phone=res.data.userphone;
            _t.access_token = res.data.access_token;
            _t.ddCorpId = res.data.ddConfigInfo.ddCorpId;
            _t.ddAgentId = res.data.ddConfigInfo.ddAgentId;
            _t.ddcode();
          } else if (res.code == 201) {
            //未绑定微信
            var query = {
              openId: _t.request.openId,
            };
            _t.$router.push({
              path: "/ddbindPhone",
              query: query,
            });
          } else {
            MessageBox.alert(res.msg, "ERROR");
          }
        },
        "dd"
      );
      this.isShow = true;
    },
    ddIsOkj() {
      this.resultdata = "请求接口";
      var _t = this;
      this.common.doActionGet(
        this.common.ddIsOk,
        { code: _t.codedd, ddAgentId: _t.ddAgentId },
        function (res) {
          console.log(res);
          if (res.code == 200) {
            //绑定成功,跳转到详情页bindDetail,否则提示失败原因
            // _t.user=res.data;
            _t.request.phone = res.data.userphone;
            _t.resultdata = res.data;
            if (_t.request.forwardType == 1) {
              let system = navigator.userAgent;
              let isAndroid =
                system.indexOf("Android") > -1 || system.indexOf("Adr") > -1; // android终端
              let isiOS = !!system.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
              if (isAndroid) {
                //android终端
                _t.resultlist = "安卓"
                // window.open('https://www.baidu.com/')
                window.open(
                  "https://" +
                    res.data.webUrl +
                    "/#/LoadingLogin/" +
                    res.data.userphone +
                    "/" +
                    _t.encryptByDES(_t.deCodeDES(res.data.userpwd)) +
                    "/" +
                    res.data.platformid,
                  "_blank"
                );

              } else if (isiOS) {
                //ios终端
                console.log("我是ios");
                _t.resultlist = "我是ios"
                // window.location.href = 'https://www.baidu.com/'
                window.location.href =
                  "https://" +
                  res.data.webUrl +
                  "/#/LoadingLogin/" +
                  res.data.userphone +
                  "/" +
                  _t.encryptByDES(_t.deCodeDES(res.data.userpwd)) +
                  "/" +
                  res.data.platformid;
              }else{
                _t.resultlist = "web"
                window.open(
                  "https://" +
                    res.data.webUrl +
                    "/#/LoadingLogin/" +
                    res.data.userphone +
                    "/" +
                    _t.encryptByDES(_t.deCodeDES(res.data.userpwd)) +
                    "/" +
                    res.data.platformid,
                  "_blank"
                );
                _t.resultdata = "https://" +
                    res.data.webUrl +
                    "/#/LoadingLogin/" +
                    res.data.userphone +
                    "/" +
                    _t.encryptByDES(_t.deCodeDES(res.data.userpwd)) +
                    "/" +
                    res.data.platformid;
              }
            } else if (_t.request.forwardType == 2) {
              let system = navigator.userAgent;
              let isAndroid =
                system.indexOf("Android") > -1 || system.indexOf("Adr") > -1; // android终端
              let isiOS = !!system.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

              if (isAndroid) {
                //android终端
                console.log("我是安卓");
                // window.open('https://www.baidu.com/')
                window.open(
                "http://wxapp.lny119.com/#/LoadingLogin/" +
                  res.data.userphone +
                  "/" +
                  res.data.userpwd +
                  "/" +
                  res.data.platformid,
                "_blank"
              );
              } else if (isiOS) {
                //ios终端
                console.log("我是ios");
                // window.location.href = 'https://www.baidu.com/'
                window.location.href ="http://wxapp.lny119.com/#/LoadingLogin/" +
                  res.data.userphone +
                  "/" +
                  res.data.userpwd +
                  "/" +
                  res.data.platformid;
              }
            }
          } else if (res.code == 201) {
            var query = {
              openId: _t.request.openId,
              ddAgentId: _t.ddAgentId,
              ddCorpId: _t.ddCorpId,
              ddcode: _t.codedd,
              forwardType: _t.request.forwardType,
            };

            _t.$router.push({
              path: "/ddbindPhone",
              query: query,
            });
          } else {
            MessageBox.alert(res.msg, "ERROR");
          }
        },
        "dd"
      );
    },
    encryptByDES(message) {
      var keyHex = CryptoJS.enc.Utf8.parse("99lny119");
      var ivHex = CryptoJS.enc.Utf8.parse("99lny119");
      var encrypted = CryptoJS.DES.encrypt(message, keyHex, {
        iv: ivHex,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });

      return encrypted.toString();
    },
    deCodeDES(message) {
      var keyHex = CryptoJS.enc.Utf8.parse("12345678");
      var ivHex = CryptoJS.enc.Utf8.parse("12345678");
      var dec = CryptoJS.DES.decrypt(message.toString(), keyHex, {
        iv: ivHex,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return dec.toString(CryptoJS.enc.Utf8);
    },
    unbindWeChat() {
      this.resdata = "1";
      var yuming = window.location.href.split("/")[2];
      if (
        yuming.indexOf("localhost") >= 0 ||
        yuming.indexOf("192.168.1") >= 0 ||
        yuming.indexOf("192.168.0.109") >= 0
      ) {
        var yuming = "https://www.lny119.com";
      }
      this.request.ddIndexUrl = yuming;

      var _t = this;
      MessageBox.confirm("解绑后将不再接受单位设备的报警信息！")
        .then((action) => {
          _t.common.doActionGet(
            _t.common.ddremoveBindLny,
            _t.request,
            function (res) {
              _t.resdata = res;
              if (res.code == 200) {
                //绑定成功,跳转到详情页bindDetail,否则提示失败原因
                var query = {
                  openId: _t.request.openId,
                  ddAgentId: _t.ddAgentId,
                  ddCorpId: _t.ddCorpId,
                  ddcode: _t.codedd,
                };
                _t.$router.push({
                  path: "/ddbindPhone",
                  query: query,
                });
              } else {
                MessageBox.alert(res.msg, "ERROR");
              }
            },
            "dd"
          );
        })
        .catch((_) => {});
    },
  },
};
</script>
<style scoped>
@import "../../../static/wechat/wechat.css";
.hello {
  height: 100%;
  padding: 0px 20px;
}
.title1 {
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  margin-top: 20px;
}
.title2 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-top: 75px;
  text-align: left;
}
.tip {
  font-size: 14px;
  color: #999999;
  text-align: left;
  margin-top: 14px;
}
.btn-code {
  width: 80px;
  height: 26px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #007aff;
  color: #007aff;
  font-size: 12px;
}
.btn-gray {
  width: 100%;
  height: 40px;
  margin-top: 100px;
}
.wechat-user-logo {
  margin-top: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/dd/ddbindDetail.vue